import { jsonp } from '@ifeng-fe/ui_base';

export const getAwardList = () => {
    return jsonp('https://shankapi.ifeng.com/feedflow/coopdoc/strapi_1ecde77bd82b4fac2afd8aeadd29de27/info/cb', {
        jsonp: 'callback',
        jsonpCallback: 'cb',
        cache: false,
    });
};
